import { render, staticRenderFns } from "./AIInsightsPanel.vue?vue&type=template&id=c12c263c&scoped=true"
import script from "./AIInsightsPanel.vue?vue&type=script&lang=js"
export * from "./AIInsightsPanel.vue?vue&type=script&lang=js"
import style0 from "./AIInsightsPanel.vue?vue&type=style&index=0&id=c12c263c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12c263c",
  null
  
)

export default component.exports